import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import ThemeService from 'themes/ThemeService';
import ProfileStore from 'stores/ProfileStore';

import styles from './CampaignOnCamAnimation.css';


function CampaignOnCamAnimation({ close, showBuyTokensModal }) {
  const theme = ThemeService.theme.onCamAnimation;

  const handleClick = useCallback(() => {
    showBuyTokensModal();
    close();
  }, [close, showBuyTokensModal]);

  if (!theme) {
    return null;
  }

  const wrapperClasses = classNames(styles.wrapper, { [styles.fixed]: ProfileStore.inCustomFullscreen });

  return (
    <div className={wrapperClasses}>
      <div className={classNames(styles.animWrapper, theme.animWrapperClass)} onClick={handleClick}>
        <div className={classNames(styles.animBackground, theme.animBackgroundClass)} />
        <div className={classNames(styles.animBackground2, theme.animBackground2Class)} />
        <div className={classNames(styles.animText, theme.animTextClass)} >
          <div>{theme.line1Text}</div>
          {Boolean(theme.line2Text) && <div>{theme.line2Text}</div>}
          {Boolean(theme.line3Text) && <div>{theme.line3Text}</div>}
        </div>
        <div className={classNames(styles.staticBackground, theme.staticBackgroundClass)} />
      </div>
    </div>
  );
}

CampaignOnCamAnimation.propTypes = {
  close: PropTypes.func.isRequired,
  showBuyTokensModal: PropTypes.func.isRequired,
};

export default observer(CampaignOnCamAnimation);
